import React, { useContext } from 'react';
import { Direction } from '../../graphql/schema/p4types';
import ReactDataGridContext from '../Context/ReactDataGridContext';
import { ArrowSortRegular } from '@fluentui/react-icons';
import { Tooltip } from '@fluentui/react-components';

export const ReorderHeader = () => {
  const { handleSort } = useContext(ReactDataGridContext);

  return (
    <Tooltip content={'Reset to entry order.'} relationship={'label'}>
      <div
        onClick={() => {
          handleSort('createdAt', Direction.Asc);
        }}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
      >
        <ArrowSortRegular />
      </div>
    </Tooltip>
  );
};
